import React, { useState, useEffect } from 'react';
import '../CSS/App.css';
import { NavScroll } from './NavBar';
import SocialLinks from "./SocialLinks";
import { supabase } from '../utils/supabaseClient';

const SQUAD_COLORS = {
  blue: '#3b82f6',
  green: '#10b981',
  pink: '#ec4899',
  gold: '#eab308'
};

export default function Roster() {
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    // Fetch players from the Supabase players_joined View
    supabase
      .from('players_joined')
      .select('*')
      .then(({ data, error }) => {
        if (error) throw error;
        setPlayers(data || []);
        setLoading(false);
      })
      .catch(err => {
        console.error("Failed to load roster data from Supabase:", err);
        setError("Unable to connect to the Supabase database. Please check configuration.");
        setLoading(false);
      });
  }, []);

  return (
    <div className='background-component roster-page-bg'>
      <NavScroll />

      <div className="roster-container">
        <h1 className="roster-title">Player Roster</h1>

        {loading ? (
          <div className="roster-loading">Loading players...</div>
        ) : error ? (
          <div className="roster-error">{error}</div>
        ) : players.length === 0 ? (
          <div className="roster-loading">No players found in database.</div>
        ) : (
          <div className="roster-table-wrapper">
            {isMobile ? (
              <table className="roster-table">
                <thead>
                  <tr>
                    <th>Player</th>
                    <th style={{ textAlign: 'center' }}>Events</th>
                    <th style={{ textAlign: 'center' }}>Points</th>
                    <th style={{ textAlign: 'center' }}>Years</th>
                  </tr>
                </thead>
                <tbody>
                  {players.map((p, index) => {
                    const isCap = Number(p.Captain) === 1;
                    const nameColor = SQUAD_COLORS[p.Team?.toLowerCase()] || '#fff';
                    return (
                      <tr key={p.Player || index}>
                        <td className="player-name" style={{ color: nameColor, textShadow: `0 0 5px ${nameColor}55` }}>
                          {p.Player}{isCap ? ' ★' : ''}
                        </td>
                        <td style={{ textAlign: 'center' }}>{p["Events Played"]}</td>
                        <td style={{ textAlign: 'center' }}>{p["Overall Points"]}</td>
                        <td style={{ textAlign: 'center' }}>0</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <table className="roster-table">
                <thead>
                  <tr>
                    <th>Player</th>
                    <th>Events</th>
                    <th>Games</th>
                    <th>Game Points</th>
                    <th>Bonus Points</th>
                    <th>Overall Points</th>
                    <th>Pts/Game</th>
                  </tr>
                </thead>
                <tbody>
                  {players.map((p, index) => {
                    const isCap = Number(p.Captain) === 1;
                    const nameColor = SQUAD_COLORS[p.Team?.toLowerCase()] || '#fff';
                    return (
                      <tr key={p.Player || index}>
                        <td className="player-name" style={{ color: nameColor, textShadow: `0 0 5px ${nameColor}55` }}>
                          {p.Player}{isCap ? ' ★' : ''}
                        </td>
                        <td>{p["Events Played"]}</td>
                        <td>{p["Games Played"]}</td>
                        <td>{p["Game Points"]}</td>
                        <td>{p["Bonus Points"]}</td>
                        <td>{p["Overall Points"]}</td>
                        <td>{typeof p["Pts/Game"] === 'number' ? p["Pts/Game"].toFixed(2) : p["Pts/Game"]}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}
          </div>
        )}
      </div>

      <SocialLinks />

      <script type="module" src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js"></script>
      <script nomodule src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js"></script>
    </div>
  );
}

